import { useCallback as o } from "react";
const a = (e) => o(
  (n) => {
    n.preventDefault(), window.open(e, "_blank", "noopener,noreferrer");
  },
  [e]
);
export {
  a as useHandleOpen
};
